import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { FileUploadSection } from "../../../../../../../../../features/file-attachments/file-upload/components/file-upload-section/file-upload-section.component";

import * as flyerDetailPageStore from "../../../store/flyer-detail-page.store";

import * as store from "../store/flyer-detail-page-assets.store";
import { getFlyerDetailPageAssetTableColumns } from "../types/flyer-detail-page-assets.functions";

export const FlyerDetailPageAssets = () => {
  const pageId = useSelector(flyerDetailPageStore.getPageId);
  const assets = useSelector(store.getPageAssets);

  useEffect(() => {
    if (pageId && !assets) {
      store.fetchPageAssets(pageId);
    }
  }, [pageId, assets]);

  return (
    <FileUploadSection
      assets={assets || []}
      isLoading={useSelector(store.isLoading)}
      onUpload={store.uploadPageAssets}
      listingColumns={getFlyerDetailPageAssetTableColumns}
    />
  );
};
